import {
  InvitationCounter,
  InvitationForm,
  InvitationHero,
  Timeline,
  Invitation2,
  SVGS,
} from ".";
import EventsMap from "./EventsMap";
import MessageToGuests from "./MessageToGuests";
import { getCloudflareImageUrl } from "../utils/imageOptimization";
import "../styles/animations.css";
import Emblem from "./Emblem";

const InvitationPreview = ({ rsvp, isEditable = false, onUpdate }) => {
  const handleUpdate = (updates) => {
    if (onUpdate) {
      onUpdate({ ...rsvp, ...updates });
    }
  };

  const toggleSection = (section) => {
    handleUpdate({ [section]: !rsvp[section] });
  };

  return (
    <div
      className={`${
        isEditable ? "h-[70vh]" : "h-[100vh]"
      } w-full flex justify-center overflow-x-hidden bg-white relative`}
    >
      <div
        className={`
          w-full max-h-fit max-w-[430px] overflow-x-hidden shadow-lg overflow-y-scroll [&::-webkit-scrollbar]:w-1
          [&::-webkit-scrollbar-track]:rounded-full
          [&::-webkit-scrollbar-track]:bg-gray-100
          [&::-webkit-scrollbar-thumb]:rounded-full
          [&::-webkit-scrollbar-thumb]:bg-gray-300
          relative
          animate-fade-up duration-1000
`}
        style={{
          backgroundImage: rsvp.texture
            ? `url(${getCloudflareImageUrl(
                rsvp.texture,
                "format=auto,width=1024",
              )})`
            : "none",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundColor: rsvp.texture ? "transparent" : rsvp.bgColor,
        }}
      >
        {rsvp.includeEmblem && (
          <Emblem rsvp={rsvp} isEditable={isEditable} onUpdate={handleUpdate} />
        )}
        {rsvp.template === 0 && (
          <InvitationHero
            rsvp={rsvp}
            isEditable={isEditable}
            onUpdate={handleUpdate}
          />
        )}
        {rsvp.template === 0 && rsvp.timelineWithQuote && (
          <Timeline
            rsvp={rsvp}
            isEditable={isEditable}
            onUpdate={handleUpdate}
          />
        )}
        {rsvp.template === 0 && rsvp.includeMap && (
          <EventsMap
            events={rsvp.events}
            mapStyle={rsvp.mapStyle || "default"}
            isEditable={isEditable}
            onStyleChange={(style) => handleUpdate({ mapStyle: style })}
            highlightColor={rsvp.highlightColor}
          />
        )}
        {rsvp.template === 0 && rsvp.countdown && (
          <InvitationCounter
            rsvp={rsvp}
            isEditable={isEditable}
            onUpdate={handleUpdate}
          />
        )}

        {rsvp.includeMessageToGuests && (
          <MessageToGuests
            rsvp={rsvp}
            isEditable={isEditable}
            onUpdate={handleUpdate}
          />
        )}
        {rsvp.template === 0 && rsvp.includeForm && (
          <InvitationForm
            rsvp={rsvp}
            isEditable={isEditable}
            onUpdate={handleUpdate}
          />
        )}
        {rsvp.template === 1 && (
          <Invitation2
            rsvp={rsvp}
            isEditable={isEditable}
            onUpdate={handleUpdate}
          />
        )}
      </div>
    </div>
  );
};
export default InvitationPreview;
